import {
  LabelPrintingLayoutAlign,
  LabelPrintingLayoutOrientation,
  LabelPrintingLayoutVerticalAlign,
} from '../types';

export enum LabelPrintingLayoutPresetKey {
  custom = 'custom',
  a4 = 'a4',
  a5 = 'a5',
  '100x50' = '100x50',
  '100x150' = '100x150',
}

export interface LabelPrintingLayoutPreset {
  width: number;
  height: number;
  cols: number;
  gap: number;
  margin: number;
  fontSize: number;
  maxLenghtDescription: number;
  orientation?: LabelPrintingLayoutOrientation;
  align: LabelPrintingLayoutAlign.left;
  verticalAlign?: LabelPrintingLayoutVerticalAlign.start;
  contentCols: number;
  withCardBorder?: boolean;
  heightAuto: boolean;
  cardHeight?: number;
  marginInline: number;
  marginBlock: number;
  oneCardPerPage?: boolean;
  descriptionWithLineClamp?: boolean;
}

export const layout_presets: Record<
  LabelPrintingLayoutPresetKey,
  LabelPrintingLayoutPreset
> = {
  custom: {
    width: 200,
    height: 300,
    cardHeight: 50,
    cols: 2,
    gap: 10,
    margin: 10,
    fontSize: 16,
    maxLenghtDescription: 30,
    align: LabelPrintingLayoutAlign.left,
    contentCols: 3,
    heightAuto: true,
    marginInline: 0,
    marginBlock: 0,
  },
  a4: {
    width: 210,
    height: 297,
    cardHeight: 50,
    cols: 3,
    gap: 5,
    margin: 10,
    fontSize: 14,
    maxLenghtDescription: 30,
    align: LabelPrintingLayoutAlign.left,
    orientation: LabelPrintingLayoutOrientation.portrait,
    contentCols: 3,
    heightAuto: true,
    marginInline: 0,
    marginBlock: 0,
  },
  a5: {
    width: 148,
    height: 210,
    cardHeight: 50,
    cols: 2,
    gap: 4,
    margin: 8,
    fontSize: 12,
    maxLenghtDescription: 30,
    align: LabelPrintingLayoutAlign.left,
    orientation: LabelPrintingLayoutOrientation.portrait,
    contentCols: 3,
    heightAuto: true,
    marginInline: 0,
    marginBlock: 0,
  },
  '100x50': {
    width: 100,
    height: 50,
    cardHeight: 50,
    cols: 1,
    gap: 2,
    margin: 2,
    fontSize: 11,
    maxLenghtDescription: 30,
    align: LabelPrintingLayoutAlign.left,
    contentCols: 1,
    heightAuto: true,
    marginInline: 0,
    marginBlock: 0,
  },
  '100x150': {
    width: 100,
    height: 150,
    cardHeight: 50,
    cols: 1,
    gap: 2,
    margin: 2,
    fontSize: 10,
    maxLenghtDescription: 30,
    align: LabelPrintingLayoutAlign.left,
    contentCols: 1,
    heightAuto: true,
    marginInline: 0,
    marginBlock: 0,
  },
};
